import { Link } from 'react-router-dom';
import type { components } from '@bookingdei/api-client/types';
import { useLanguage } from '../../shell/language-context';
import { Cover } from './hx-cover';
import { Ic } from './hx-icon';
import type { HomeFormat } from './use-home-format';

type BusinessSummary = components['schemas']['BusinessSummary'];

// "Trending right now." (design `.sec.alt`, FR-C20): the top ten from the trending rollup —
// the same signal as /trending, so a rank here is the rank there — as tall cards in a
// sideways rail. Rankings are organic; no placement enters this rail.
export function HxTrending({ items, fmt }: { items: BusinessSummary[]; fmt: HomeFormat }) {
  const { t, lang } = useLanguage();
  if (items.length === 0) return null;
  const top = items.slice(0, 10);
  return (
    <section className="sec alt">
      <div className="in">
        <div className="sh rv">
          <div>
            <h2>{t('dc50.trend.title')}</h2>
            <p>{t('dc50.trend.sub', { n: fmt.num(top.length) })}</p>
          </div>
          <Link className="more" to="/trending">
            {t('hx.trend.all')} <Ic id="arrow" />
          </Link>
        </div>
        <div className="hs big">
          {top.map((b, i) => {
            const name = lang === 'bn' && b.name_bn ? b.name_bn : b.name;
            return (
              <Link key={b.id} to={`/b/${b.slug}`} className="tc rv">
                <Cover src={b.cover_image?.['800'] ?? b.cover_image?.['400']} categoryId={b.category_id} id={b.id} />
                <span className="rk">
                  <Ic id="trophy" />
                  {t('dc50.trend.rank', { n: fmt.num(i + 1) })}
                </span>
                <span className="cat2">{fmt.catLabel(b.category_id)}</span>
                <div className="tt">
                  <small>{b.area_name}</small>
                  <b>{name}</b>
                  <span>
                    ★ {fmt.rating(b.rating)} · {fmt.priceFrom(b)}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
